import { ExpressedGenesFilterOption } from '../types';
import { ExpressedGenes } from '../../components';

export const config: ExpressedGenesFilterOption = {
  id: 'omicsExplorer.filters.expressedGenes',
  title: {
    id: 'omicsExplorer.filters.expressedGenes',
    defaultMessage: 'Expression Rank Order',
  },
  content: ExpressedGenes,
  injectedProps: {
    searchKey: 'orderBy',
    expressedGenesOption: {
      id: 'omicsExplorer.filters.expressedGenes',
      top: {
        id: 'omicsExplorer.filters.expressedGenes.top',
        defaultMessage: 'Order by Highest Expressed',
      },
      bottom: {
        id: 'omicsExplorer.filters.expressedGenes.bottom',
        defaultMessage: 'Order by Lowest Expressed',
      },
    },
  },
};
